import { defineStore } from "pinia";

export const useContratTemplateStore = defineStore('contratTemplate', {
    state: () => ({
        contratTemplate: {},
        contratTemplates: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setContratTemplate(contratTemplate) {
            this.contratTemplate = contratTemplate
        },
        setContratTemplates(contratTemplates) {
            this.contratTemplates = contratTemplates
        },
        addContratTemplate(contratTemplate) {
            this.contratTemplates.unshift(contratTemplate)
        },
        updateContratTemplate(contratTemplate) {
            let index = this.contratTemplates.findIndex(cl => cl.id === contratTemplate.id)
            this.contratTemplates.splice(index, 1, contratTemplate)
        },
        deleteContratTemplate(contratTemplate) {
            let index = this.contratTemplates.findIndex(cl => cl.id === contratTemplate.id)
            this.contratTemplates.splice(index, 1)
        },
    },
});